import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';

type ApiEnvelope<T> = { data: T; message?: string; statusCode: number };

export interface PartnerLoginResult {
  token: string;
  partnerId: string;
  partnerName: string;
  phone?: string;
  role: string;
}

export async function partnerLogin(phone: string, password: string): Promise<PartnerLoginResult> {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/partner/login`,
    data: { phone, password },
  });
  return (response.data as ApiEnvelope<PartnerLoginResult>).data;
}
